export default  ["driver","area","profile","expenses","packages","reports","user", "customRate", "common", "admin", "partner","driverPackageInvoices"];
